import{C as o}from"./events-Dm1k7AS7.js";document.addEventListener("alpine:init",()=>{Alpine.data("productForm",()=>({items:[],isSubmitting:!1,init(){document.addEventListener(o.ADDED,e=>{this.isSubmitting=!1}),document.addEventListener(o.BUNDLE_UPDATE,e=>{const{groupId:t,items:s}=e.detail;this.items=this.items.filter(i=>!i.groupId||i.groupId!==t),s.forEach(i=>{this.addItem(i.id,i.quantity,i.price);const n=this.items.find(r=>r.id===i.id);n&&(n.groupId=t)})}),document.addEventListener("product:swap",e=>{this.items=[]})},addItem(e,t,s=0,i=null,properties=null){
  const n = this.items.findIndex(r => r.id === e);
  if (n >= 0) {
    if (t > 0) {
      this.items[n].quantity = t;
      this.items[n].price = s;
      i && (this.items[n].selling_plan = i);
      if (properties && Object.keys(properties).length > 0) {
        this.items[n].properties = properties;
      }
    } else {
      this.items.splice(n, 1);
    }
  } else if (t > 0) {
    const r = { id: e, quantity: t, price: s };
    i && (r.selling_plan = i);
    if (properties && Object.keys(properties).length > 0) {
      r.properties = properties;
    }
    this.items.push(r);
  }
},
getGiftProperties(){
  const props = {};
  const form = document.querySelector("#product-form");
  if (!form) return props;

  const selector = [
    'input[name*="rc_gift_"]',
    'textarea[name*="rc_gift_"]',
    'select[name*="rc_gift_"]'
  ].join(',');

  form.querySelectorAll(selector).forEach(el => {
    if (!el.name || el.value === "") return;

    // Grab the rc_gift key from the name, e.g. "__rc_gift_recipient_first_name"
    const match = el.name.match(/__?rc_gift_[^\]\]]+/) || el.name.match(/__?rc_gift_[^&]+/);
    if (!match) return;

    const key = match[0];
    props[key] = el.value;
    const key1 = match[0].replace('__rc_gift_','').replaceAll('_',' ');
    const cap = this.capitalizeFirst(key1);
    props[cap] = el.value;
  });

  return props;
},
capitalizeFirst(sentence) {
  if (!sentence) return "";
  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
},
addSingleProduct(e,t=1){
  const s = document.querySelector("#product-form"),
        i = s?.querySelector('input[name="selling_plan"]'),
        n = s.querySelector("[data-timesact-selling-plan]");

  let r = i ? i.value : null;
  n?.value && (r = n.value);

  const giftProps = this.getGiftProperties();

  this.addItem(e, t, 0, r, giftProps);
  return this.submitToCart();
},
getTotalQuantity(){return this.items.reduce((e,t)=>e+t.quantity,0)},getBundleItemsPrice(){return this.items.reduce((e,t)=>{const s=t.price||0;return e+s*t.quantity},0)},hasVariant(e){return this.items.some(t=>t.id===e)},async submitToCart(){
  if (this.items.length === 0) {
    console.warn("No items to submit to cart");
    return;
  }
  this.isSubmitting = !0;
  try {
    let payload;

    if (this.items.length === 1) {
      const item = this.items[0];
      payload = {
        id: item.id,
        quantity: item.quantity
      };
      if (item.selling_plan) {
        payload.selling_plan = item.selling_plan;
      }
      if (item.properties && Object.keys(item.properties).length > 0) {
        payload.properties = item.properties;
      }
    } else {
      // Multi-item payload: items already include properties
      payload = { items: this.items };
    }

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json"},
      body: JSON.stringify(payload)
    });

    if (res.ok) {
      const data = await res.json();
      const i = this.getTotalQuantity();
      document.dispatchEvent(new CustomEvent(o.ADD, { detail: { ...data, items_increment: i }}));
      this.items = [];
      document.dispatchEvent(new CustomEvent(o.SUBMITTED));
    } else {
      const text = await res.text();
      throw new Error(`Cart submission failed: ${text}`);
    }
  } catch(e) {
    console.error("Cart submission error:", e);
    let msg = e.message || "Failed to add items to cart";
    if (msg.includes("422") || msg.includes("inventory")) {
      msg = "One or more items are out of stock";
    } else if (msg.includes("network") || msg.includes("fetch")) {
      msg = "Connection error. Please check your internet and try again.";
    }
    document.dispatchEvent(new CustomEvent(o.ERROR, { detail: { message: msg, title: "Cart Error" }}));
    this.isSubmitting = !1;
  }
}
}))});
